<template>
	<div  style="width: 100%;">
		
		<!-- 抽屉 drawer_info :destroy-on-close="true" -->
		<el-drawer :visible.sync="show" :with-header="false" :size="size"  :before-close="handleClose">
		
			<div class="drawer_box" v-loading="isloading">
				<!--  -->
				<div class="drawer_head" ref="getheight">
					<slot name="head"></slot>
				</div>
				<!--  -->
				<!--  -->
				<div class="drawer_body">
					<slot name="body"></slot>
				</div>
				<!--  -->
			</div>
		</el-drawer>
		<!--  -->
	</div>
</template>

<script>
	
	var that
	export default {
		name: "popdrawer",
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			size: {
				type: Number,
				default: 774,
			},
		},
		data() {
			return {
				isloading: true,
			}
		},
		created() {
			that = this
		},
		watch: {
			
			show(){
				if(this.show) {
					this.getvanhe()
				}
			},
		},
		methods: {
			// 弹出  点击遮罩和 x 关闭弹出
			handleClose(done) {
				this.$emit('update:show', false)
			}, 
			getvanhe(){
				setTimeout(() => {
					let h1 = document.documentElement.clientHeight
					let h2 = this.$refs.getheight ? this.$refs.getheight.offsetHeight : 0;
					console.log(h1,h2,'getvanhe---------------------' )
					let num = (h1 - h2) - 48
					let height = `height: ${num}px`
					this.$emit('retuheig', {height})
				}, 300)
			},
		},
		
	}
	
</script>

<style scoped lang="scss">
	@import "@/assets/css/public.scss";
</style>
